import ErrorOutline from "@mui/icons-material/ErrorOutline";
import HowToReg from "@mui/icons-material/HowToReg";
import PersonAddAlt from "@mui/icons-material/PersonAddAlt";

export const USER_MANAGEMENT_METRICS = [
  {
    title: "Total Users",
    value: "5",
    icon: PersonAddAlt,
    tone: "primary",
  },
  {
    title: "Active Users",
    value: "3",
    icon: HowToReg,
    tone: "primary",
  },
  {
    title: "User Limit",
    value: "5 / 100",
    icon: ErrorOutline,
    tone: "warning",
  },
];

export const USER_MANAGEMENT_ACTIONS = {
  EDIT: "edit",
  RESET_PASSWORD: "reset_password",
  DEACTIVATE: "deactivate",
  REACTIVATE: "reactivate",
  SEND_INVITE: "send_invite",
  RESEND_INVITE: "resend_invite",
  CANCEL: "cancel",
};

export const USER_MANAGEMENT_ACTION_LABELS = {
  [USER_MANAGEMENT_ACTIONS.EDIT]: "Edit",
  [USER_MANAGEMENT_ACTIONS.RESET_PASSWORD]: "Reset Password",
  [USER_MANAGEMENT_ACTIONS.DEACTIVATE]: "Deactivate",
  [USER_MANAGEMENT_ACTIONS.REACTIVATE]: "Reactivate",
  [USER_MANAGEMENT_ACTIONS.SEND_INVITE]: "Send Invite",
  [USER_MANAGEMENT_ACTIONS.RESEND_INVITE]: "Resend Invite",
  [USER_MANAGEMENT_ACTIONS.CANCEL]: "Cancel",
};

export const RESET_PASSWORD_OPTIONS = [
  {
    value: "link",
    label: "Send password reset link",
  },
  {
    value: "temporary_password",
    label: "Send temporary password",
  },
];

export const USER_MANAGEMENT_PERMISSION_NOTICE = {
  message: "New users will have the same account access as you",
  permissions: [
    "Manage campaigns",
    "View Reporting",
    "Manage media plans",
    "Update account/profile settings",
    "Manage payments",
    "Receive account communications",
    "Invite and manage users",
  ],
};
